import { zodResolver } from "@hookform/resolvers/zod";
import React, { useMemo } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { generateDefaultValues } from "./helpers";
import { Schema, schema } from "./schema";
import { HookFormCheckbox } from "../../../components/HookForm/Checkbox";
import { HookForm } from "../../../components/HookForm/HookForm";
import { LocationPreferences } from "../../../models/LocationPreferences";

import "./styles.scss";

export interface IEditLocationPreferencesFormProps {
  preferences: LocationPreferences;
  submit: (data: LocationPreferences) => Promise<void>;
}

export const EditLocationPreferencesForm: React.FC<
  IEditLocationPreferencesFormProps
> = (props: IEditLocationPreferencesFormProps) => {
  const { preferences, submit } = props;
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`locationPreferencesPage.editLocationPreferencesForm.${key}`);

  const defaultValues = useMemo(() => {
    return generateDefaultValues(preferences);
  }, [preferences]);

  const form = useForm<Schema>({
    resolver: zodResolver(schema),
    defaultValues,
  });

  const onSubmit = async (data: Schema) => {
    const payload: LocationPreferences = {
      ...data,
      id: preferences.id,
      location_id: preferences.location_id,
    };
    try {
      await submit(payload);
      toast.success(t("success"));
      form.reset(data);
    } catch (error) {
      // Do nothing, axios will handle the error
    }
  };

  return (
    <div className="edit-location-preferences-form white-border-panel">
      <h2>{t("title")}</h2>
      <HookForm form={form} onSubmit={onSubmit} submitButtonLabel={t("submit")}>
        <HookFormCheckbox
          name="manages_gbp_review_replies"
          label={t("manages_gbp_review_replies")}
        />
      </HookForm>
    </div>
  );
};
